<template>
  <div>
    <a-upload
      ref="upload"
      :file-list="fileList"
      :action="uploadAction"
      list-type="picture-card"
      @change="handleChange"
      @preview="handlePreview"
      :remove="handleRemove"
      :max-count="limit"
      :before-upload="handleBeforeUpload"
      :headers="{
        'Access-Token': token,
      }"
      :disabled="disabled"
      class="avatar-uploader"
      style="height: 102px"
    >
      <template v-if="fileList.length < limit">
        <a-icon type="plus"/>
      </template>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { urlApi } from '@/api/common'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  props: {
    // 绑定变量名 用于校验
    name: {
      type: String,
      default: 'logo',
    },
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 5,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    fileUnit: {
      type: String,
      default: 'Mb',
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ['png', 'jpg', 'jpeg'],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    files: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      uploadAction: urlApi.uploadImage, // 替换为你的上传API地址
      fileList: [], // 存储上传的图片列表
      previewVisible: false,
      previewImage: '',
      ACCESS_TOKEN,
    }
  },
  created() {
    const regex = /(data:image\/png;base64,[^\s]+)/g
    const arr = this.files.match(regex) || []
    if (this.files !== null && this.files.length > 0) {
      this.fileList = []
      let list = []
      if (this.files.indexOf('data:image/png;base64,') !== -1) {
        list = arr
      } else {
        list = this.files.split(',')
      }
      for (let i = 0; i < list.length; i++) {
        const map = {
          uid: `${-1 - i}`, // 唯一标识，可以使用负值表示已有文件
          name: `existing-image.jpg`, // 文件名
          status: 'done', // 状态为已完成
          url: list[i], // 图片地址
        }
        this.fileList.push(map)
      }
    }
  },
  watch: {
    limit(newVal, oldVal) {
      if (newVal < oldVal) {
        if (newVal < this.fileList.length) {
          this.fileList = this.fileList.slice(0, newVal)
        }
      }
    },
    files(newVal) {
      if (typeof newVal === 'string' && newVal.length > 0) {
        this.fileList = []
        const regex = /(data:image\/png;base64,[^\s]+)/g
        const arr = newVal.match(regex) || []
        let list = []
        if (newVal.indexOf('data:image/png;base64,') !== -1) {
          list = arr
        } else {
          list = newVal.split(',')
        }
        for (let i = 0; i < list.length; i++) {
          const map = {
            uid: `${-1 - i}`,
            name: `existing-image.jpg`,
            status: 'done',
            url: list[i],
          }
          this.fileList.push(map)
        }
      } else if (!newVal) {
        this.fileList = []
      }
    },
    value: {
      handler(val) {
        if (val) {
          // 根据 limit 处理输入值：limit=1 时 val 是字符串，否则是URL数组
          let list = []
          if (this.limit === 1) {
            // 单张图片：val 是字符串，转为单元素数组
            list = [val]
          } else {
                      // 多张图片：val 可能是URL数组或逗号分隔的字符串
          if (Array.isArray(val)) {
            // 如果输入是数组，直接使用（假设是URL数组）
            list = val
          } else if (typeof val === 'string') {
            // 如果是字符串，按逗号分割并过滤空值
            list = val.split(',').filter(item => item && item.trim())
          }
          }
          
          // 将数组转为对象数组（内部使用，不影响外部输出）
          this.fileList = list.map((item, index) => {
            if (typeof item === 'string') {
              item = {
                uid: item,
                name: this.extractFileName(item),
                url: item,
                status: 'done',
              }
            } else if (item && typeof item === 'object' && item.pic_path) {
              // 如果是键值对格式，转换为组件需要的格式
              item = {
                uid: item.pic_path,
                name: item.pic_title || this.extractFileName(item.pic_path),
                url: item.pic_path,
                status: 'done',
              }
            }
            return item
          })
          
          // 当外部值变化时，向外输出纯URL数组（多张）或字符串（单张）
          // 注意：这里不要立即 emit，避免初始化时的循环调用
          // 只有在用户操作（上传/删除）时才向外输出
        } else {
          this.fileList = []
          // 清空时也不要立即向外输出，避免初始化时的循环调用
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['token']),
  },
  methods: {
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = ''
      separator = separator || ','
      for (const i in list) {
        strs += list[i].url + separator
      }
      return strs !== '' ? strs.substr(0, strs.length - 1) : ''
    },
    // 获取包含文件名和URL的完整信息
    getFileInfo(list) {
      console.log('list', list)
      return list.map((item) => ({
        url: item.url,
        name: item.name,
        uid: item.uid,
      }))
    },
    // 从URL中提取文件名
    extractFileName(url) {
      if (!url) return '图片'
      try {
        // 从URL中提取文件名
        const urlObj = new URL(url)
        const pathname = urlObj.pathname
        const fileName = pathname.split('/').pop()
        // 移除文件扩展名
        return fileName ? fileName.replace(/\.[^/.]+$/, '') : '图片'
      } catch (error) {
        // 如果URL解析失败，尝试从字符串中提取文件名
        const fileName = url.split('/').pop()
        return fileName ? fileName.replace(/\.[^/.]+$/, '') : '图片'
      }
    },
    // 以下为上传功能相关方法
    handleChange({ file, fileList }) {
      this.fileList = fileList
      if (file.status === 'done') {
        const current = this.fileList.find((item) => {
          return item.name === file.name
        })
        current.url = file.response.data
        current.name = file.name
        // 根据 limit 决定输出格式：limit=1 时输出字符串，否则输出URL数组
        if (this.limit === 1) {
          this.$emit('input', current.url)
        } else {
          console.log('this.fileList', this.fileList)
          // 多张图片时只输出URL数组
          const urlList = this.fileList.map(item => item.url).filter(url => url)
          this.$emit('input', urlList)
        }

        // 清除外层校验
        // const prop = this.$parent.$parent.$parent.$parent._props.prop
        // if (prop) {
        //   this.$parent.$parent.$parent.$parent.$parent.clearValidate([this.name])
        // }
      } else if (file.status === 'error') {
        const index = this.fileList.findIndex((item) => item.uid === file.uid || item.name === file.name)
        if (index !== -1) {
          const item = this.fileList[index]
          item.status = 'error'
          item.error = { statusText: '上传错误' }
          item.response = undefined
        }
        file.error = { statusText: '上传错误' }
        file.response = undefined
      }
    },
    handleBeforeUpload(file) {
      return new Promise(async (resolve, reject) => {
        let isImg = false

        //  文件名判断
        if (file.name.length > 100) {
          this.$message.error(`文件名长度限制为100,文件名超出长度限制!`)
          reject(new Error('文件名错误'))
          return false
        }

        // 格式判断
        if (this.fileType.length) {
          let fileExtension = ''
          if (file.name.lastIndexOf('.') > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase()
          }
          isImg = this.fileType.some((type) => {
            if (fileExtension && fileExtension.indexOf(type) > -1) {
              return true
            } else {
              return false
            }
          })
        } else {
          isImg = file.type.indexOf('image') > -1
        }

        if (!isImg) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}图片格式文件!`)
          reject(new Error('文件格式错误'))
          return false
        }

        // 文件大小判断
        if (this.fileSize) {
          const isLt =
            this.fileUnit === 'Mb' ? file.size / 1024 / 1024 < this.fileSize : file.size / 1024 < this.fileSize

          if (!isLt) {
            this.$message.error(`上传图片大小不能超过 ${this.fileSize} ${this.fileUnit}!`)
            reject(new Error('上传图片大小错误'))
            return false
          }
        }
        resolve(file)
      })
    },
    // 以下为预览相关方法
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    // 删除图片
    handleRemove(file, fileList) {
      if (file.status === 'done') {
        const findex = this.fileList.map((f) => f.name).indexOf(file.name)
        this.fileList.splice(findex, 1)
        // 根据 limit 决定输出格式：limit=1 时输出空字符串，否则输出URL数组
        if (this.limit === 1) {
          this.$emit('input', '')
        } else {
          // 多张图片时只输出URL数组
          const urlList = this.fileList.map(item => item.url).filter(url => url)
          this.$emit('input', urlList)
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
:deep(.ant-upload-list-item-info::before) {
  left: 0;
  top: 0;
}
</style>